import React from 'react';

const SwiftIcon = ({ classes }) => (
  <svg className={classes} role="img" viewBox="0 0 504 504"><path class="st0" d="M307.4,40.9c213.7,145.4,144.4,305.2,144.4,305.2s60.7,68.5,36.3,128.5c0,0-25.2-41.9-67-41.9  c-40.4,0-64.3,41.9-145.9,41.9C93.8,474.6,7.8,323,7.8,323C171.3,430.8,283,354.4,283,354.4C209.2,311.7,52.6,107.3,52.6,107.3  C189.1,223.5,248,254,248,254C212.6,225,113.9,82.9,113.9,82.9c79,79.9,236,191.3,236,191.3C394.9,151.1,307.4,40.9,307.4,40.9z" /></svg>
);

export default SwiftIcon;
